
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},[_c('path',{attrs:{"d":"M9.793 6.293a1 1 0 000 1.414L14.086 12l-4.293 4.293a1 1 0 101.414 1.414l5-5a1 1 0 000-1.414l-5-5a1 1 0 00-1.414 0z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      